import { throttle } from './util';

let lastScrollDistance = 0;

const headerHeight = 130;
const COMPACT_HEADER_CLASS = 'compact';
const INACTIVE_HEADER_CLASS = 'inactive';

let headerEl = document.querySelector('.header');
let hamburgerEl = document.querySelector('.hamburger');
let mobileNavEl = document.querySelector('.mobile-nav');

hamburgerEl.addEventListener('click', e => {
    e.preventDefault();

    if (hamburgerEl.classList.contains('active')) {
        headerEl.classList.remove('active');
        hamburgerEl.classList.remove('active');
        mobileNavEl.classList.remove('open');

        return;
    }

    headerEl.classList.add('active');
    hamburgerEl.classList.add('active');
    mobileNavEl.classList.add('open');
});

document.querySelectorAll('.nav-items a').forEach(navLink => {
    navLink.addEventListener('click', () => {
        let activeNavItem = document.querySelector('.nav-items .active');
        if (activeNavItem) {
            activeNavItem.classList.remove('active');
        }

        navLink.parentElement.classList.add('active');
    });
});

document.querySelectorAll('.mobile-nav-items a').forEach(navLink => {
    navLink.addEventListener('click', () => {
        if (navLink.href === window.location.href) {
            hamburgerEl.click();
        }
    });
});

window.addEventListener('scroll', throttle(250, () => {
    let scrolledDistance = window.pageYOffset;
    let scrollDifference = lastScrollDistance - scrolledDistance;

    if (! headerEl) {
        return;
    }

    if (scrolledDistance > headerHeight) {
        // Hide header when distance scrolled is greater than the height of the header
        if (! headerEl.classList.contains(COMPACT_HEADER_CLASS)) {
            headerEl.classList.add(COMPACT_HEADER_CLASS);
        }
    } else {
        // Show header if distance scrolled is less than the height of the header
        headerEl.classList.remove(COMPACT_HEADER_CLASS);
    }

    if (scrolledDistance <= 0) {
        // Scrolled to the very top, element sticks to the top
        headerEl.classList.remove(INACTIVE_HEADER_CLASS);
    } else if (scrollDifference > 0 && headerEl.classList.contains(INACTIVE_HEADER_CLASS)) {
        // Scrolled up, element slides in
        headerEl.classList.remove(INACTIVE_HEADER_CLASS);
    } else if (scrollDifference < 0) {
        // scrolled down
        if (scrolledDistance > headerHeight) {
            // Scrolled down, element slides out
            headerEl.classList.add(INACTIVE_HEADER_CLASS);
        }
    }

    lastScrollDistance = scrolledDistance;
}));

featherify.on('mounted', e => {
    document.querySelector('.page-title').innerText
        = e.newDocument.querySelector('.page-title')
            .innerText.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();

    const hideFooter = e.newDocument.querySelector('footer').classList.contains('hidden');
    document.querySelector('footer').classList[hideFooter ? 'add' : 'remove']('hidden');
});
